// constants
import { ShippingsActionTypes } from "./constants";

//Action
export interface ShippingsActionType {
  type:
    | ShippingsActionTypes.GET_LIST_SHIPPINGS_ERROR
    | ShippingsActionTypes.GET_LIST_SHIPPINGS_SUCCESS
    | ShippingsActionTypes.GET_LIST_SHIPPINGS
    | ShippingsActionTypes.GET_SHIPPING
    | ShippingsActionTypes.GET_SHIPPING_SUCCESS
    | ShippingsActionTypes.GET_SHIPPING_ERROR
    | ShippingsActionTypes.UPDATE_SHIPPING
    | ShippingsActionTypes.UPDATE_SHIPPING_SUCCESS
    | ShippingsActionTypes.UPDATE_SHIPPING_ERROR
    | ShippingsActionTypes.UPDATE_STATUS_SHIPPING
    | ShippingsActionTypes.UPDATE_STATUS_SHIPPING_SUCCESS
    | ShippingsActionTypes.UPDATE_STATUS_SHIPPING_ERROR
    | ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING
    | ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_SUCCESS
    | ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_ERROR
    | ShippingsActionTypes.DELETE_SHIPPING
    | ShippingsActionTypes.DELETE_SHIPPING_SUCCESS
    | ShippingsActionTypes.DELETE_SHIPPING_ERROR
    | ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST
    | ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_SUCCESS
    | ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_ERROR;
  payload: {} | string;
}

//Interfaces
interface ShippingsData {
  iteam?: any[];
  total?: number;
  country?: string;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface ShippingUpdate {
  comment: string;
  description: string;
  orderDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}

interface GetShipping {
  id: string;
}

interface DeleteShipping {
  ids: string[];
}

//Shipping_List
export const ShippingsGetListSuccess = (
  actionType: string,
  data: ShippingsData | {}
): ShippingsActionType => ({
  type: ShippingsActionTypes.GET_LIST_SHIPPINGS_SUCCESS,
  payload: { actionType, data },
});

export const ShippingsGetListError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.GET_LIST_SHIPPINGS_ERROR,
  payload: { actionType, error },
});

export const getShippingsList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  deliveryGuy: string = "",
  country: string = "ic",
  status: string = "",
  product: string = "",
  boutique: string = ""
): ShippingsActionType => ({
  type: ShippingsActionTypes.GET_LIST_SHIPPINGS,
  payload: { keyword, limit, skip, owner, deliveryGuy, country, status, product, boutique },
});

//Update Shipping
export const updateShippingSuccess = (
  actionType: string,
  data: ShippingUpdate | {}
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_SHIPPING_SUCCESS,
  payload: { actionType, data },
});
export const updateShippingError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_SHIPPING_ERROR,
  payload: { actionType, error },
});

export const updateShipping = (
  id: string,
  data: ShippingUpdate
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_SHIPPING,
  payload: { id, ...data },
});

//Update Status Shipping
export const updateStatusShippingSuccess = (
  actionType: string,
  data: ShippingUpdate | {}
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_STATUS_SHIPPING_SUCCESS,
  payload: { actionType, data },
});
export const updateStatusShippingError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_STATUS_SHIPPING_ERROR,
  payload: { actionType, error },
});

export const updateStatusShipping = (
  id: string,
  {
    status,
    comment,
    cashAmount,
    cashCurrency,
    podPhotoUrl,
    podSignatureUrl,
    receivedBy,
    location,
    outcome,
    reprogrammedFor,
  }: {
    status: string;
    comment?: string;
    cashAmount?: number;
    cashCurrency?: string;
    podPhotoUrl?: string;
    podSignatureUrl?: string;
    receivedBy?: string;
    location?: { lat?: number; lng?: number };
    outcome?: string;
    reprogrammedFor?: string;
  }
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_STATUS_SHIPPING,
  payload: {
    id,
    status,
    comment,
    cashAmount,
    cashCurrency,
    podPhotoUrl,
    podSignatureUrl,
    receivedBy,
    location,
    outcome,
    reprogrammedFor,
  },
});

//Update Delivery Shipping
export const updateDeliveryShippingSuccess = (
  actionType: string,
  data: ShippingUpdate | {}
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_SUCCESS,
  payload: { actionType, data },
});
export const updateDeliveryShippingError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_ERROR,
  payload: { actionType, error },
});

export const updateDeliveryShipping = (
  id: string,
  { delivery }
): ShippingsActionType => ({
  type: ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING,
  payload: { id, delivery },
});

//GET Shipping

export const getShippingSuccess = (
  actionType: string,
  data: GetShipping | {}
): ShippingsActionType => ({
  type: ShippingsActionTypes.GET_SHIPPING_SUCCESS,
  payload: { actionType, data },
});
export const getShippingError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.GET_SHIPPING_ERROR,
  payload: { actionType, error },
});

export const getShipping = (id: string): ShippingsActionType => ({
  type: ShippingsActionTypes.GET_SHIPPING,
  payload: { id },
});

//DELETE Shipping

export const deleteShippingSuccess = (
  actionType: string,
  data: DeleteShipping | {}
): ShippingsActionType => ({
  type: ShippingsActionTypes.DELETE_SHIPPING_SUCCESS,
  payload: { actionType, data },
});
export const deleteShippingError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.DELETE_SHIPPING_ERROR,
  payload: { actionType, error },
});

export const deleteShipping = (ids: string[]): ShippingsActionType => ({
  type: ShippingsActionTypes.DELETE_SHIPPING,
  payload: { ids },
});

export const downloadShippingsListSuccess = (
  actionType: string,
  data: any
): ShippingsActionType => ({
  type: ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_SUCCESS,
  payload: { actionType, data },
});

export const downloadShippingsListError = (
  actionType: string,
  error: string
): ShippingsActionType => ({
  type: ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_ERROR,
  payload: { actionType, error },
});

export const downloadShippingsList = (
  keyword: string = "",
  owner: string = "",
  deliveryGuy: string = "",
  deliveryGuyName: string = "",
  country: string = "ic",
  status: string = "",
  product: string = ""
): ShippingsActionType => ({
  type: ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST,
  payload: { keyword, owner, deliveryGuy, deliveryGuyName, country, status, product },
});
